export default {
  PURPLE: '#3D58ED',
  PURPLE_TRANSPARENT: '#3D58ED2A',
  GREEN: '#00EC00',
  WHITE: '#FFFFFF',
};
